import moment from "moment";

export const allowTwoDecimal = (e) => {
    const currentValue = e.target.value;
    const allowedLength = currentValue.includes(".") ? 5 : 3;
    const splittedValue = currentValue.split(".");
    const decimalDigits = splittedValue[1];
    const isDecimal = decimalDigits !== undefined;
    if (e.key === "a" && (e.ctrlKey || e.metaKey)) { return; }
    if (e.key === 'Tab') { return; }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'ArrowLeft') { return; }
    if (e.key === "Backspace" && e.key === "Delete") { return; }
    if ((currentValue.length >= allowedLength && e.key !== "Backspace" && e.key !== "Delete")
        || (isDecimal && decimalDigits.length > 3 && e.key !== "Backspace" && e.key !== "Delete") ||
        (["e", "E", "+", "-"].includes(e.key))) { e.preventDefault(); }
};